import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import DirectorUpdateModalUI from './DirectorUpdateModalUI.js'

class DirectorUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      address: null,
      addressError: null,
      sharePledgedNumber: null,
      sharePledgedNumberError: null,
      sharePledgedPercent: null,
      sharePledgedPercentError: null,
      nduPercent: null,
      nduPercentError: null,
      pledgor: 'false',
      pledgorError: null,
      guarantor: 'false',
      guarantorError: null,
      cibilScore: null,
      cibilScoreError: null,
      phoneNumber: null,
      phoneNumberError: null,
      email: null,
      emailError: null,
    }
  }

  render() {
    let booleanList = [
      { key: 'true', value: 'Yes' },
      { key: 'false', value: 'No' },
    ]
    return (
      <DirectorUpdateModalUI
        context={this.props.context}
        loan={this.props.loan}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        name={this.props.selectedUser && this.props.selectedUser.name}

        address={this.state.address}
        onAddressChange={(event) => { this.setState({ address: event.target.value }) }}
        addressError={this.state.addressError}
        setAddressError={(error) => { this.setState({ addressError: error }) }}

        sharePledgedNumber={this.state.sharePledgedNumber}
        onSharePledgedNumberChange={(event) => { this.setState({ sharePledgedNumber: event.target.value }) }}
        sharePledgedNumberError={this.state.sharePledgedNumberError}
        setSharePledgedNumberError={(error) => { this.setState({ sharePledgedNumberError: error }) }}

        sharePledgedPercent={this.state.sharePledgedPercent}
        onSharePledgedPercentChange={(event) => { this.setState({ sharePledgedPercent: event.target.value }) }}
        sharePledgedPercentError={this.state.sharePledgedPercentError}
        setSharePledgedPercentError={(error) => { this.setState({ sharePledgedPercentError: error }) }}

        nduPercent={this.state.nduPercent}
        onNduPercentChange={(event) => { this.setState({ nduPercent: event.target.value }) }}
        nduPercentError={this.state.nduPercentError}
        setNduPercentError={(error) => { this.setState({ nduPercentError: error }) }}

        pledgor={this.state.pledgor}
        onPledgorChange={(event) => { this.setState({ pledgor: event.target.value }) }}
        pledgorError={this.state.pledgorError}
        setPledgorError={(error) => { this.setState({ pledgorError: error }) }}

        guarantor={this.state.guarantor}
        onGuarantorChange={(event) => { this.setState({ guarantor: event.target.value }) }}
        guarantorError={this.state.guarantorError}
        setGuarantorError={(error) => { this.setState({ guarantorError: error }) }}
        booleanList={booleanList}

        cibilScore={this.state.cibilScore}
        onCibilScoreChange={(event) => { this.setState({ cibilScore: event.target.value }) }}
        cibilScoreError={this.state.cibilScoreError}
        setCibilScoreError={(error) => { this.setState({ cibilScoreError: error }) }}

        phoneNumber={this.state.phoneNumber}
        onPhoneNumberChange={(event) => { this.setState({ phoneNumber: event.target.value }) }}
        phoneNumberError={this.state.phoneNumberError}
        setPhoneNumberError={(error) => { this.setState({ phoneNumberError: error }) }}

        email={this.state.email}
        onEmailChange={(event) => { this.setState({ email: event.target.value }) }}
        emailError={this.state.emailError}
        setEmailError={(error) => { this.setState({ emailError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  componentWillReceiveProps(props) {
    if (props.selectedUser) {
      this.setState({
        address: props.selectedUser.address || '',
        sharePledgedNumber: props.selectedUser.sharePledgedNumber || '',
        sharePledgedPercent: props.selectedUser.sharePledgedPercent || '',
        nduPercent: props.selectedUser.nduPercent || '',
        pledgor: '' + props.selectedUser.pledgor,
        guarantor: '' + props.selectedUser.guarantor,
        cibilScore: props.selectedUser.cibilScore || '',
        phoneNumber: props.selectedUser.phoneNumber || '',
        email: props.selectedUser.email || '',
        submitted: false,
        errorList: null
      })
    }
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    console.log(this.props.context);

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/termSheet/users/${this.props.selectedUser.userId}`,
      this.onSubmitCallback, {
      address: this.state.address,
      sharePledgeNumber: this.state.sharePledgedNumber,
      sharePledgedPercent: this.state.sharePledgedPercent,
      nduPercent: this.state.nduPercent,
      pledgor: this.state.pledgor,
      guarantor: this.state.guarantor,
      cibilScore: this.state.cibilScore,
      phoneNumber: this.state.phoneNumber,
      email: this.state.email,
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default DirectorUpdateModalSF
